import List from "@/components/list";
import vue from "@/main";
import router from "@/router";

const Table = (args) => {
  const { listeners, props } = args;

  // 编辑申报
  function editReportClass({ uuid, classStatus }) {
    router.push({ path: "classReport/add", query: { id: uuid, status: classStatus } });
  }

  // 删除申报
  function deleteReportClass(row) {
    vue.$emit("deleteClassReport", row);
  }

  // 发布申报班级
  function publishReportClass(row) {
    vue.$emit("publishClassReport", row);
  }

  // 短信管理
  function goSmsManage(row) {

    vue.$emit("goSmsManage", row);
  }

  // 办班计划管理
  function reportClassPlan(row) {
    router.push({
      path: "classReport/manage",
      query: { uuid: row.uuid },
    });
  }
  // 点击跳转申报详情
  function goClassReportDetail(row) {
    router.push({
      path: "classReport/detail",
      query: { id: row.uuid },
    });
  }


  const Deal = ({ props: { vo } }) => {
    const { row } = vo;
    const dealConf = [
      [
        row.publishStatus === 0 ? "icon_fabu" : "icon_fabu-disable",
        "发布",
        row.publishStatus === 0
          ? () => {
            publishReportClass(row);
          }
          : () => { },
        "classReport:publish",
      ],
      ["icon-edit", "编辑", () => editReportClass(row), "classReport:update"],
      // 如果未发布或者待申报状态显示删除按钮
      [
        row.publishStatus === 0 || row.reportStatus == 1 ? "icon-delete" : "icon-delete-disable",
        "删除",
        row.publishStatus === 0 || row.reportStatus == 1
          ? () => {
            deleteReportClass(row);
          }
          : () => { },
        "classReport:delete",
      ],
      [
        row.publishStatus == 1 ? "ic-report-sms" : "ic-report-sms-disable",
        "短信通知",
        row.publishStatus == 1
          ? () => {
            goSmsManage(row)
          }
          : () => { },
        "classReport:sms",
      ],
    ];


    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
        <el-tooltip
          content="办班计划审核"
          placement="top"
          v-permission={'classReport:pageAudit'}
        >
          <i
            class="ic-report-plan"
            onClick={() => reportClassPlan(row)}>
            {
              row.isRed == 1 ? (<div class="red-badge"></div>) : null
            }
          </i>
        </el-tooltip>
      </div>
    );
  };

  const ReportStatusName = ({ props: { vo } }) => {
    const reportStatusName = vo.row.reportStatusName
      ? vo.row.reportStatusName
      : "--";
    return <span>{reportStatusName}</span>;
  };

  const ReportName = ({ props: { vo } }) => {
    const item = vo.row;
    return (
      <div class="base-hover-char" onClick={() => goClassReportDetail(item)}>
        {item.reportName}
      </div>
    );
  };

  const AccountTableConfig = [
    {
      label: "申报名称",
      prop: "reportName",
      minWidth: "200",
      render: (vo) => <ReportName vo={vo} />,
    },
    {
      label: "申报开始时间",
      prop: "reportStartTime",
      width: "100",
      showOverflowTooltip: true,
    },
    {
      label: "申报结束时间",
      prop: "reportEndTime",
      width: "100",
      showOverflowTooltip: true,
    },
    {
      label: "发布状态",
      prop: "publishStatusName",
      width: "90",
      showOverflowTooltip: true,
    },
    {
      label: "申报状态",
      prop: "reportStatusName",
      width: "90",
      render: (vo) => <ReportStatusName vo={vo} />,
    },
    {
      label: "创建时间",
      prop: "createDate",
      width: "170",
      showOverflowTooltip: true,
    },
  ];
  AccountTableConfig.push({
    label: "操作",
    fixed: "right",
    width: "160",
    render: vo => <Deal vo={vo} />
  })
  return (
    <List
      {...args}
      talbeCols={AccountTableConfig}
    />
  );
};
export default Table;
